import { useState, useMemo, FocusEvent, useRef, MouseEvent } from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import MoleculeXSSearch from "Components/Molecules/XSSearch";
import OrganismXSNowContentsHeader from "Components/Organisms/XSNowContentsHeader";
import OrganismFooter from "Components/Organisms/XSFooter";
import MoleculeXSNowContentsHeader from "Components/Molecules/XSNowContentsHeader";
import OrganismNowContents from "Components/Organisms/XSNowContents";
import MoleculeKeywords from "Components/Molecules/Keywords";

import * as Types from "Types";
import * as actions from "actions";
import * as enums from "enumerations";

export interface PropsType extends Types.Default {
   nows: any;
}

dayjs.locale("ko");

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;

const HeaderWrap = styled.div`
   width: 100%;
   border-bottom: 1px solid #000;
`;

const NowContentsWrap = styled.div`
   position: relative;
`;

const SearchWrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: flex-start;
   position: absolute;
   left: 0px;
   top: 0px;
   width: 100%;
   height: 100%;
   padding-top: 180px;
   box-sizing: border-box;
   visibility: hidden;
   background-color: rgba(255, 255, 255, 0);
   transition: background-color 0.3s ease-in-out;
   ${({ css }) => css}
`;

const cssHeader = css`
   width: 100%;
   max-width: 1200px;
`;

const ChildNowContentsHeader = styled(MoleculeXSNowContentsHeader)`
   margin: 49px 0px 10px 0px;
`;
const Keywords = styled(MoleculeKeywords)`
   margin-top: 50px;
`;
const Footer = styled(OrganismFooter)`
   margin-top: 110px;
`;

export default function XSNows(props: PropsType) {
   const XSSearchStatus = useSelector(({ XSSearch }: Types.State) => XSSearch.status);
   const XSSearchStatusMemo = useMemo(() => XSSearchStatus, [XSSearchStatus]);
   const refSearchInput: any = useRef<HTMLInputElement>(null);
   const dispatch = useDispatch();
   const [searchValue, setSearchValue] = useState("");

   const params = useParams();
   const contentHeaderProps =
      props.nows?.status === enums.api.resolved
         ? {
              title: props.nows.data.title,
              subtitle: props.nows.data.subtitle,
              date: dayjs(props.nows.data.updated_datetime || props.nows.data.insert_datetime).format("YYYY-MM-DD"),
           }
         : {
              title: params.uriTitle,
              subtitle: props.nows.data.subtitle,
              date: dayjs().format("YYYY-MM-DD"),
           };

   function onBlur(ev: FocusEvent) {
      ev.preventDefault();
      dispatch({ type: actions.XSSearch.closing });
      setTimeout(function () {
         dispatch({ type: actions.XSSearch.closed });
      }, 301);
   }

   function onSuccess() {
      refSearchInput.current!.focus();
   }

   function searchOnClick(ev: MouseEvent<HTMLElement>) {
      ev.preventDefault();
      console.log("XSSearchStatusMemo", XSSearchStatusMemo);
      if (XSSearchStatusMemo !== enums.XSSearchStatuses.idle && searchValue) {
         window.location.href = "https://art-map.co.kr/search/list.php?keyword=" + encodeURIComponent(searchValue);
      } else {
         dispatch({ type: actions.XSSearch.opening });
         setTimeout(function () {
            dispatch({ type: actions.XSSearch.opened });
            onSuccess();
         }, 301);
      }
   }

   function searchOnChange(ev: any) {
      setSearchValue(ev.target.value);
   }

   function searchOnKeyDown(ev: any) {
      if (ev.key === "Enter") {
         window.location.href = "https://art-map.co.kr/search/list.php?keyword=" + encodeURIComponent(searchValue);
      }
   }

   return (
      <Wrap>
         <HeaderWrap>
            <OrganismXSNowContentsHeader searchOnClick={searchOnClick} onSuccess={onSuccess} css={cssHeader}></OrganismXSNowContentsHeader>
         </HeaderWrap>
         <NowContentsWrap>
            <ChildNowContentsHeader {...contentHeaderProps}></ChildNowContentsHeader>
            <OrganismNowContents></OrganismNowContents>
            <Keywords keywords={(props.nows.data.keywords || "").split(",")}></Keywords>
            <SearchWrap
               css={
                  XSSearchStatusMemo === enums.XSSearchStatuses.idle
                     ? css`
                          visibility: hidden;
                       `
                     : XSSearchStatusMemo === enums.XSSearchStatuses.openInit || XSSearchStatusMemo === enums.XSSearchStatuses.input
                     ? css`
                          visibility: visible;
                          background-color: rgba(255, 255, 255, 0.9);
                       `
                     : css`
                          visibility: visible;
                          background-color: rgba(255, 255, 255, 0);
                       `
               }
            >
               <MoleculeXSSearch
                  inputRef={refSearchInput}
                  onBlur={onBlur}
                  onChange={searchOnChange}
                  onKeyDown={searchOnKeyDown}
                  value={searchValue}
                  css={
                     XSSearchStatusMemo === enums.XSSearchStatuses.input
                        ? css`
                             visibility: visible;
                             opacity: 1;
                          `
                        : css`
                             visibility: hidden;
                             opacity: 0;
                          `
                  }
               ></MoleculeXSSearch>
            </SearchWrap>
         </NowContentsWrap>
         <Footer></Footer>
      </Wrap>
   );
}
